'use strict';
const calculateEmojis = require('@mindmup/mapjs-core/src/util/calculate-emojis');
module.exports = function TSpanStickersEngine(tspanTextEngine) {
	const self = this;
	self.writeStickers = function (stickers, size, totalWidth) {
		const emojis = calculateEmojis(stickers, {ignoreVariants: true});
		return tspanTextEngine.writeLine(
			emojis.join(''),
			{fontSize: size - 2, weight: 'regular', family: 'emoji'},
			'black',
			totalWidth
		);
	};
};
